export default class Errors {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }

    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }

    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field) {
        if (this.errors[field]) {
            if (_.isArray(this.errors[field])) {
                return _.join(this.errors[field], "<br>");
            } else {
                return this.errors[field];
            }
        }
    }

    /**
     * Retrieve the error message for a field.
     */
    all() {
        if (_.size(this.errors) > 0) {
            let errorMsg = [];
            _.forEach(this.errors, function(error) {
                errorMsg.push(error[0]);
            });

            return _.join(errorMsg, "<br>");
        }
    }

    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        this.errors = errors;
    }

    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }
}
